import http from '@/utils/http';
const preUrl = '/api-lcrm/homePageMore';
// 组织维度
// 1.1 各维度收入对比（外部各行业收入情况、各组织收入情况）
export const getIncomeAngles = (data) => {
    return http({
        url: `${preUrl}/income/incomeAngles`,
        method: 'post',
        data
    });
};
// 1.2 外部行业-小行业收入（小行业弹窗P2）
export const getIncomeTypeIndustry = (data) => {
    return http({
        url: `${preUrl}/income/incomeTypeIndustry`,
        method: 'post',
        data
    });
};

// 1.3 外部行业-客户收入详情(客户系+客户系P2)
export const getIncomeTypeCustomer = (data) => {
    return http({
        url: `${preUrl}/income/incomeTypeCustomer`,
        method: 'post',
        data
    });
};
// 1.4 分公司-经营中心收入详情(经营中心P2)
export const getIncomeCompanySitelev2 = (data) => {
    return http({
        url: `${preUrl}/income/incomeCompanySitelev2`,
        method: 'post',
        data
    });
};
// 1.5  外部行业-客户收入详情TOP(外部收入客户明细P1)
export const getIncomeTypeCustomerTop = (data) => {
    return http({
        url: `${preUrl}/income/incomeTypeCustomerTop`,
        method: 'post',
        data
    });
};

// 1.6 外部行业-客户-结算客户(结算客户明细P1)
export const getIncomeTypeCustomerTopDetai = (data) => {
    return http({
        url: `${preUrl}/income/incomeTypeCustomerTopDetail`,
        method: 'post',
        data
    });
};

// 1.7 历史趋势(历史趋势P1)
export const getOverdueHistory = (data) => {
    return http({
        url: `${preUrl}/overdue/overdueHistory`,
        method: 'post',
        data
    });
};

// 1.8 各片区对比(各片区对比P1)
export const getOverdueArea = (data) => {
    return http({
        url: `${preUrl}/overdue/overdueArea`,
        method: 'post',
        data
    });
};

// 1.9 行业详情(外部行业逾期情况P1)
export const getOverdueType = (data) => {
    return http({
        url: `${preUrl}/overdue/overdueType`,
        method: 'post',
        data
    });
};

// 2.0 大专司逾期情况(专司逾期情况P1)
export const getOverdueBigEbcdName = (data) => {
    return http({
        url: `${preUrl}/overdue/overdueBigEbcdName`,
        method: 'post',
        data
    });
};

// 2.1分公司逾期情况(分公司逾期情况P1)
export const getOverdueCompany = (data) => {
    return http({
        url: `${preUrl}/overdue/overdueCompany`,
        method: 'post',
        data
    });
};

// 2.2商机趋势规模(商机趋势P1)
export const getOpportunityHistorySj = (data) => {
    return http({
        url: `${preUrl}/opportunity/opportunityHistorySj`,
        method: 'post',
        data
    });
};

// 2.3各维度对比-商机规模(各组织商机规模P1)
export const getOpportunityAnglesSj = (data) => {
    return http({
        url: `${preUrl}/opportunity/opportunityAnglesSj`,
        method: 'post',
        data
    });
};

// 2.4历史趋势-达成(历史趋势P1)
export const getOpportunityHistory = (data) => {
    return http({
        url: `${preUrl}/opportunity/opportunityHistory`,
        method: 'post',
        data
    });
};

// 2.5各维度对比-签单达成(各组织签单达成P1)
export const getOpportunityAnglesYm = (data) => {
    return http({
        url: `${preUrl}/opportunity/opportunityAnglesYm`,
        method: 'post',
        data
    });
};

// 营销人员签单达成P3
export const getOpportunityUserOrderDetail = (data) => {
    return http({
        url: `${preUrl}/opportunity/opportunityUserOrderDetail`,
        method: 'post',
        data
    });
};

// 营销人员签单达成-合计
export const getOpportunityUserOrderDetailTop = (data) => {
    return http({
        url: `${preUrl}/opportunity/opportunityUserOrderDetailTop`,
        method: 'post',
        data
    });
};

// 个人维度
// 1.1 收入客户明细
export const getPersonalIncomeCustomerDetail = (data) => {
    return http({
        url: `${preUrl}/income/personalCustomerDetail`,
        method: 'post',
        data
    });
};

// 1.2 逾期应收客户明细
export const getPersonalOverdueCustomerDetail = (data) => {
    return http({
        url: `${preUrl}/overdue/personalCustomerDetail`,
        method: 'post',
        data
    });
};

// 1.3 商机规模
export const getPersonalOpportunityScale = (data) => {
    return http({
        url: `${preUrl}/opportunity/opportunityScalePage`,
        method: 'post',
        data
    });
};

// 1.4 签单达成
export const getPersonalSignOrderDeal = (data) => {
    return http({
        url: `${preUrl}/signOrder/signOrderDealPage`,
        method: 'post',
        data
    });
};

// 行业详情-小行业(小行业P2)-V2.2
export const getOverdueTypeIndustry = (data) => {
    return http({
        url: `${preUrl}/overdue/overdueTypeIndustry`,
        method: 'post',
        data
    });
};
// 行业详情-客户(客户系)-V2.2
export const getOverdueCustomer = (data) => {
    return http({
        url: `${preUrl}/overdue/overdueCustomer`,
        method: 'post',
        data
    });
};

// 行业详情-客户-top(客户系)-V2.2
export const getOverdueCustomerTop = (data) => {
    return http({
        url: `${preUrl}/overdue/overdueCustomerTop`,
        method: 'post',
        data
    });
};

// 行业详情-客户-结算客户(结算客户)-V2.2
export const getOverdueCustomerLms = (data) => {
    return http({
        url: `${preUrl}/overdue/overdueCustomerLms`,
        method: 'post',
        data
    });
};

// 逾期时间分布(逾期时间P2)-V2.2
export const getOverdueTimeDistribute = (data) => {
    return http({
        url: `${preUrl}/overdue/overdueTimeDistribute`,
        method: 'post',
        data
    });
};
// 分公司详情-客户(客户系)-V2.2
export const getOverdueCompanyCustomer = (data) => {
    return http({
        url: `${preUrl}/overdue/overdueCompanyCustomer`,
        method: 'post',
        data
    });
};
// 商机二级页面-片区-客户(客户系)-第一层弹窗-V2.3 - wy
export const getOpportunityAngleCustomer = (data) => {
    return http({
        url: `${preUrl}/opportunity/opportunityAngleCustomer`,
        method: 'post',
        data
    });
};
// 商机二级页面-片区-客户(客户系)-第一层弹窗-合计-V2.3 - wy
export const getOpportunityAngleCustomerTop = (data) => {
    return http({
        url: `${preUrl}/opportunity/opportunityAngleCustomerTop`,
        method: 'post',
        data
    });
};
// 商机二级页面-经营中心-客户(客户系)-第一层弹窗-V2.3 - wy
export const getOpportunityAnglesCompanySitelev2Sj = (data) => {
    return http({
        url: `${preUrl}/opportunity/opportunityAnglesCompanySitelev2Sj`,
        method: 'post',
        data
    });
};
// 商机二级页面-小行业-商机规模)[小行业-第一层弹窗-V2.3 - wy
export const getOpportunityAnglesTypeIndustrySj = (data) => {
    return http({
        url: `${preUrl}/opportunity/opportunityAnglesTypeIndustrySj`,
        method: 'post',
        data
    });
};
// 商机二级页面--片区-商机全流程-客户(客户)-第二层弹窗-V2.3 - wy
export const getOpportunityAngleCustomerDetail = (data) => {
    return http({
        url: `${preUrl}/opportunity/opportunityAngleCustomerDetail`,
        method: 'post',
        data
    });
};
// 签单二级页面-经营中心-客户(客户系)-第一层弹窗-V2.3 - wy
export const getOpportunityAnglesCompanySitelev2Ym = (data) => {
    return http({
        url: `${preUrl}/opportunity/opportunityAnglesCompanySitelev2Ym`,
        method: 'post',
        data
    });
};
// 签单二级页面-小行业-签单规模)[小行业-第一层弹窗-V2.3 - wy
export const getOpportunityAnglesTypeIndustryYm = (data) => {
    return http({
        url: `${preUrl}/opportunity/opportunityAnglesTypeIndustryYm`,
        method: 'post',
        data
    });
};
// 客户KPI及客诉二级页面-外部客户达成率-ylx
export const getCustomerAchievement = (data) => {
    return http({
        url: `${preUrl}/customer/customerKpiAngle`,
        method: 'post',
        data
    });
};
// 客户KPI及客诉二级页面-客户KPI明细-ylx
export const getCustomerKpiDetail = (data) => {
    return http({
        url: `${preUrl}/customer/customerKpiDetail`,
        method: 'post',
        data
    });
};
// 客户KPI及客诉二级页面-重大客诉-ylx
export const getCustomerComplaintDetail = (data) => {
    return http({
        url: `${preUrl}/customer/customerMajorComplaintsDetail`,
        method: 'post',
        data
    });
};
// 首页-客户服务-工单-ylx
export const getCustomerOrderAngle = (data) => {
    return http({
        url: `${preUrl}/customer/customerOrderAngle`,
        method: 'post',
        data
    });
};
// 首页-客户服务-满意度-明细-ylx
export const getCustomerSatisfactionAngle = (data) => {
    return http({
        url: `${preUrl}/customer/customerSellerInvestigationAngle`,
        method: 'post',
        data
    });
};
